import { BaseModel } from '../base.model';

export class DispatchStatusDto extends BaseModel {
  public DispatchStatusID: number;
  public Name: string;
  public isFinalStatus: boolean;
  public isSystemDependent: boolean;
  public Position: number;
  public bActive: boolean;
  public DispatchGroupID: number;
  public FieldDispatchGroupID: number;
  public bHideHRView: boolean;
  public bHideFieldView: boolean;
  public bHideJobsRecruiter: boolean;
  public bHideJobsMgr: boolean;

  public get DispatchStatusId(): number {
    return this.DispatchStatusID;
  }

  public set DispatchStatusId(value: number) {
    this.DispatchStatusID = value;
  }

  public get DispatchStatusName(): string {
    return this.Name;
  }

  public set DispatchStatusName(value: string) {
    this.Name = value;
  }

  constructor(o: any = null) {
    super(o);
  }
}
